import { render, staticRenderFns } from "./BuyDid.vue?vue&type=template&id=ec976ce4&scoped=true&"
import script from "./BuyDid.vue?vue&type=script&lang=js&"
export * from "./BuyDid.vue?vue&type=script&lang=js&"
import style0 from "./BuyDid.vue?vue&type=style&index=0&id=ec976ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec976ce4",
  null
  
)

component.options.__file = "BuyDid.vue"
export default component.exports